/************************************************************
 Health Care Namespace
 ************************************************************/

window.healthCarePlanNS = {
    // Private Variables
    _row:null,
    _action:null,
    _callback:null,
    // Execute Action
    executeAction:function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        healthCarePlanNS._action = action;
        healthCarePlanNS._row = row;
        healthCarePlanNS._callback = callback;
        debug.log('healthCarePlanNS', action, row, callback, wfId)

        // Cancel Requisition                        
        if (actionId == 120) {
            healthCarePlanNS.openCancelModal(healthCarePlanNS.cancelReasonModalHandler);                           
        } // Request requisition
        else if (actionId == 119) {        
            healthCarePlanNS.executeGenericAction();
        } // conferred
        else if (actionId == 121) {
            var params = {requisition_id: healthCarePlanNS._row.task_id};
            Hades.loadScreen('/healthcare_plan/requisition/requisition_conference', params);
        } else if (wfId == globalConstants.WF_HCP_PORTAL && actionId == 146) {
            healthCarePlanNS.printEligibilityRequest(this._action, this._row, this._callback);
        } else if (wfId == globalConstants.WF_HCP_PLANS && actionId == 156) {
            healthCarePlanNS.printConferenceTicket(this._action, this._row, this._callback);
        } else if (wfId == globalConstants.WF_HCP_PLANS && actionId == 158) {
            healthCarePlanNS.openCancelConferenceModal();
        }else if (wfId == globalConstants.WF_HCP_PORTAL && actionId == 145 /* Cancel */) {
            healthCarePlanNS.update_all_requisitions_status();
        } else if (wfId == globalConstants.WF_HCP_PLANS && actionId == 148) {
            healthCarePlanNS.printPreAuthRequest(this._action, this._row, this._callback);
        } else if (wfId == globalConstants.WF_HCP_PLANS && actionId == 149) {
            healthCarePlanNS.onOpenMoreInfoModal();
        } else if (wfId == globalConstants.WF_HCP_PLANS && actionId == 153) {
            healthCarePlanNS.onOpenMoreInfoModal();
        } else if (wfId == globalConstants.WF_HCP_PLANS && actionId == 147) {
            healthCarePlanNS.onOpenMoreInfoModal();
        } else if (wfId == globalConstants.WF_HCP_PROCEDURES && actionId == 151) {
            healthCarePlanNS.onProcedureAction();
        } else if (wfId == globalConstants.WF_HCP_PROCEDURES && actionId == 152) {
            healthCarePlanNS.onProcedureAction();
        } else if (wfId == globalConstants.WF_HCP_PROCEDURES && actionId == 149) {
            healthCarePlanNS.onOpenMoreInfoModal();
        } else if (wfId == globalConstants.WF_HCP_PROCEDURES && actionId == 153) {
            healthCarePlanNS.onOpenMoreInfoModal();
        } else if (wfId == globalConstants.WF_HCP_PLANS && actionId == 152 /* Rejected */) {
            workflow.executeGenericAction(healthCarePlanNS._action, healthCarePlanNS.checkAllRequisitionStatus, healthCarePlanNS._row);
        /* Reimbursement Requisition WF */
        } else if (wfId == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_PROCESS && actionId == 163 /* Reimbursement Request Payment - Conference */) {
            var params = {requisition_id: healthCarePlanNS._row.task_id};
            Hades.loadScreen('/healthcare_plan/requisition/requisition_conference', params);
        } else if (wfId == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_PROCESS && actionId == 161 /* Reimbursement Request Ask More Info */) {
            healthCarePlanNS.onOpenMoreInfoModal();
        } else if (wfId == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_PROCESS && actionId == 164 /* Reimbursement Request Undo Aproved */) {
            healthCarePlanNS.openCancelConferenceModal();
        } else if (wfId == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_PROCEDURES && (actionId == 188) /* Reimbursement Request Procedures WF */) {
            healthCarePlanNS.openReason(healthCarePlanNS.rejectProcedure);
        } else if (wfId == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_PROCEDURES && ((actionId != 169) && (actionId != 186)) /* Reimbursement Request Procedures WF */) {
            healthCarePlanNS.onReimbursementProceduresAction();
        } else if (wfId == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_PROCEDURES && (actionId == 169 || actionId == 186)) {
            healthCarePlanNS.onOpenMoreInfoModal();
        }else if (wfId == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_REQUEST_PROCESS && actionId == 171 /* Cancel REIMBURSEMENT PROCESS */) {
            healthCarePlanNS.update_all_reimbursement_processes_status();
        }else if (wfId == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_PROCESS && actionId == 165 /* Cancel REIMBURSEMENT Aprovement */) {
            healthCarePlanNS.update_all_reimbursement_processes_status();
        }else if (wfId == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_PROCESS && actionId == 162 /* Cancel REIMBURSEMENT Aprovement */) {
            healthCarePlanNS.reverse_reimbursement_requisition_detail();
        }else if (wfId == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_REQUEST_PROCESS && actionId == 173 /* Print Disease Expenses Form  */) {
            healthCarePlanNS.printDiseaseExpensesForm(this._action, this._row, this._callback);
        }else if (wfId == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_PROCESS && actionId == 174 /* Response */) {
            healthCarePlanNS.onOpenMoreInfoModal();
        }else {
            healthCarePlanNS.executeGenericAction();
        }
    },
    // Execute Generic Action
    executeGenericAction:function () {
        workflow.executeGenericAction(healthCarePlanNS._action, healthCarePlanNS._callback, healthCarePlanNS._row);
    },
    openReason: function(callback){

        var params = {
            task_id:healthCarePlanNS._action.task_id,
            wf_id:healthCarePlanNS._action.wf_id,
            wf_status_id: null,
            wf_action_id:healthCarePlanNS._action.wf_action_id};

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content: data, autoScale: true, autoDimensions: true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                healthCarePlanNS._callback(false, healthCarePlanNS._action, healthCarePlanNS._row);
            });
    },
    rejectProcedure: function(event, data){
        $.fancybox.close(true);

        healthCarePlanNS._action.params.reason_id = data.reasonId;
        healthCarePlanNS._action.params.other_reason = data.otherReason;
        healthCarePlanNS._action.params.wf_justification_date = data.date;
        healthCarePlanNS._action.params.wf_justification_hour = data.hour;

        healthCarePlanNS.onReimbursementProceduresAction();

    },
    update_all_requisitions_status: function () {

        var parameters = {
            eligibility_request_id: healthCarePlanNS._row.task_id
        }


        // #### update all requisistions to cancel ####
        $.getJSON('/health_care_portal/eligibility/update_to_cancel_all_requisitions', parameters)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data != null /* success */){
                    if (data == 0){
                        bootbox.alert(GlobalTranslations['APP_LABEL.2755']);
                    } else {
                        healthCarePlanNS.executeGenericAction();
                    }

                } else {
                    healthCarePlanNS._callback(true, healthCarePlanNS._action, healthCarePlanNS._row);
                }

            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                healthCarePlanNS._callback(false, healthCarePlanNS._action, healthCarePlanNS._row);
            });
        //#### update all requisistions to cancel  ####


    },

    reverse_reimbursement_requisition_detail: function(){

        var parameters = {
            reimbursement_process_id: healthCarePlanNS._action.task_id
        }

        // #### update all requisitions to edit again  ####
        $.getJSON('/hcp_reimbursement_management/reimbursement_request/reverse_reimbursement_requisition_detail', parameters)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data != null /* success */){
                    if (data == 0){
                        bootbox.alert(GlobalTranslations['APP_LABEL.2786']);
                    } else {
                        healthCarePlanNS.executeGenericAction();
                    }

                } else {
                    healthCarePlanNS._callback(true, healthCarePlanNS._action, healthCarePlanNS._row);
                }

            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                healthCarePlanNS._callback(false, healthCarePlanNS._action, healthCarePlanNS._row);
            });
        //#### update all requisitions to edit again  ####


    },


    update_all_reimbursement_processes_status: function () {

        var parameters = {
            reimbursement_request_id: healthCarePlanNS._row.task_id
        }


        // #### update all processes to cancel ####
        $.getJSON('/hcp_reimbursement_management/reimbursement_request/update_to_cancel_all_reimbursement_processes_status', parameters)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data != null /* success */){
                    if (data == 0){
                        bootbox.alert(GlobalTranslations['APP_LABEL.2786']);
                    } else {
                        healthCarePlanNS.executeGenericAction();
                    }

                } else {
                    healthCarePlanNS._callback(true, healthCarePlanNS._action, healthCarePlanNS._row);
                }

            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                healthCarePlanNS._callback(false, healthCarePlanNS._action, healthCarePlanNS._row);
            });
        //#### update all processes to cancel  ####

    },

    checkAllRequisitionStatus: function () {

        var parameters = {
            requisition_id: healthCarePlanNS._row.task_id
        };

        // #### check all requisistions ####
        $.getJSON('/health_care_portal/eligibility/check_all_requisitions_status', parameters)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data == 1 /* success */){
                    healthCarePlanNS.executeGenericAction();
                } else {
                    healthCarePlanNS._callback(true, healthCarePlanNS._action, healthCarePlanNS._row);
                }

            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                healthCarePlanNS._callback(false, healthCarePlanNS._action, healthCarePlanNS._row);
            });
        //#### check all requisistions ####

    },

    onProcedureAction: function () {


        $.each(healthCarePlanNS._action.params.procedures, function(index, elem){


            if (healthCarePlanNS._action.params.item_id == elem.item_id) {

                var params = {
                    task_id: healthCarePlanNS._action.task_id,
                    wf_id: healthCarePlanNS._action.wf_id,
                    wf_status_id: healthCarePlanNS._action.from_state_id,
                    wf_action_id: healthCarePlanNS._action.wf_action_id,
                    item_id:  healthCarePlanNS._action.params.item_id,
                    requisition_type_id: elem.requisition_type_id,
                    quantity: elem.quantity,
                    plafond_cover_id: elem.plafond_cover_id,

                    request_date: healthCarePlanNS._action.params.request_date,
                    eligibility_type_id: healthCarePlanNS._action.params.eligibility_type_id,
                    plafond_id: healthCarePlanNS._action.params.plafond_id
                };


                $.getJSON('/health_care_portal/eligibility/wf_execute_action', params)
                    .done(function (data, status, xhr) {
                        Hades.checkIfUserIsAuthorized(data, status, xhr);

                        if (data.success) {
                            healthCarePlanNS._callback(true, healthCarePlanNS._action, healthCarePlanNS._row);
                        } else {
                            //Hades.showError(Hades.workflowErrorMsg(), data.error, xhr, status, data.error);
                            bootbox.alert(data.error);

                            Hades.hideLoading();

                        }
                    })
                    .fail(function (xhr, status, error) {
                        Hades.showError(error, xhr.responseText, xhr, status, error);
                        Hades.hideLoading();

                });

            } else {

                var params = {
                    task_id: healthCarePlanNS._action.task_id,
                    item_id:  elem.item_id,
                    requisition_type_id: elem.requisition_type_id,
                    quantity: elem.quantity,
                    plafond_cover_id: elem.plafond_cover_id,

                    request_date: healthCarePlanNS._action.params.request_date,
                    eligibility_type_id: healthCarePlanNS._action.params.eligibility_type_id,
                    plafond_id: healthCarePlanNS._action.params.plafond_id
                };

                $.post('/health_care_portal/eligibility/save_other_procedures_without_update_status', params, null, 'json')
                    .done(function (data, status, xhr) {
                        Hades.checkIfUserIsAuthorized(data, status, xhr);

                        if (data.success != true) {
                            Hades.hideLoading();
                        } else {
                            Hades.reloadScreen();
                        }
                    })
                    .fail(function (xhr, status, error) {
                        Hades.hideLoading();
                });



            }


        });




    },

    onReimbursementProceduresAction: function () {

        debug.log('onReimbursementProceduresAction ', healthCarePlanNS._action.params);

        $.each(healthCarePlanNS._action.params.procedures, function(index, elem){


            if ( (healthCarePlanNS._action.params.item_id == elem.item_id) && (healthCarePlanNS._action.params.entry_order_number == elem.entry_order_number) ) {

                var params = {
                    task_id: healthCarePlanNS._action.task_id,
                    wf_id: healthCarePlanNS._action.wf_id,
                    wf_status_id: healthCarePlanNS._action.from_state_id,
                    wf_action_id: healthCarePlanNS._action.wf_action_id,
                    item_id:  healthCarePlanNS._action.params.item_id,
                    plafond_cover_type_id: healthCarePlanNS._action.params.plafond_cover_type_id,
                    quantity: elem.quantity,
                    requisition_type_id: elem.requisition_type_id,
                    discount_type_id: elem.discount_type_id,
                    request_date: healthCarePlanNS._action.params.request_date,
                    plafond_id: healthCarePlanNS._action.params.plafond_id,
                    base_price: elem.base_price,
                    discount: elem.discount,
                    other_entities_value: elem.other_entities_value,
                    refund: elem.refund,

                    sams_value: elem.sams_value,
                    document_number: elem.document_number,
                    nif_number: elem.nif_number,
                    document_date: elem.document_date,
                    vat_type_id: elem.vat_type_id,
                    infarmed: elem.infarmed,
                    simposium: elem.simposium,
                    other_discount: elem.other_discount,

                    mechanografic_number: healthCarePlanNS._action.params.mechanografic_number,
                    bdp_process: healthCarePlanNS._action.params.bdp_process,
                    sams_posible_value: elem.sams_posible_value,
                    entry_order_number: elem.entry_order_number,

                    reason_id: healthCarePlanNS._action.params.reason_id,
                    other_reason: healthCarePlanNS._action.params.other_reason,
                    wf_justification_date: healthCarePlanNS._action.params.wf_justification_date,
                    wf_justification_hour: healthCarePlanNS._action.params.wf_justification_hour
                };


                $.getJSON('/hcp_reimbursement_management/reimbursement_request/wf_execute_procedure_action', params)
                    .done(function (data, status, xhr) {
                        Hades.checkIfUserIsAuthorized(data, status, xhr);

                        if (data.success) {
                            healthCarePlanNS._callback(true, healthCarePlanNS._action, healthCarePlanNS._row);
                        } else {
                            //Hades.showError(Hades.workflowErrorMsg(), data.error, xhr, status, data.error);
                            bootbox.alert(data.error);

                            Hades.hideLoading();

                        }
                    })
                    .fail(function (xhr, status, error) {
                        Hades.showError(error, xhr.responseText, xhr, status, error);
                        Hades.hideLoading();

                    });

            } else {

                var params = {
                    task_id: healthCarePlanNS._action.task_id,
                    item_id:  elem.item_id,
                    requisition_type_id: elem.requisition_type_id,
                    quantity: elem.quantity,
                    plafond_cover_type_id: healthCarePlanNS._action.params.plafond_cover_type_id,
                    quantity: elem.quantity,
                    requisition_type_id: elem.requisition_type_id,
                    discount_type_id: elem.discount_type_id,
                    request_date: healthCarePlanNS._action.params.request_date,
                    plafond_id: healthCarePlanNS._action.params.plafond_id,
                    barcode: healthCarePlanNS._action.params.barcode,
                    base_price: elem.base_price,
                    discount: elem.discount,
                    other_entities_value: elem.other_entities_value,
                    refund: elem.refund,

                    sams_value: elem.sams_value,
                    document_number: elem.document_number,
                    nif_number: elem.nif_number,
                    document_date: elem.document_date,
                    vat_type_id: elem.vat_type_id,
                    infarmed: elem.infarmed,
                    simposium: elem.simposium,
                    other_discount: elem.other_discount,

                    mechanografic_number: healthCarePlanNS._action.params.mechanografic_number,
                    bdp_process: healthCarePlanNS._action.params.bdp_process,
                    sams_posible_value: elem.sams_posible_value,
                    entry_order_number: elem.entry_order_number
                };

                $.post('/hcp_reimbursement_management/reimbursement_request/save_other_procedures_without_update_status', params, null, 'json')
                    .done(function (data, status, xhr) {
                        Hades.checkIfUserIsAuthorized(data, status, xhr);

                        if (data.success != true) {
                            Hades.hideLoading();
                        } else {
                            Hades.reloadScreen();
                        }
                    })
                    .fail(function (xhr, status, error) {
                        Hades.hideLoading();
                    });



            }


        });

    },

    // Reimbursement Requisition - More Info

    onMoreInfoReimbursementRequisition: function (event, data) {

        debug.log('Gravar os documentos', data);

        $.post('/hcp_reimbursement_management/reimbursement_request/reimbursement_requisition_patient_save_document', data, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    bootbox.alert(data.error);

                    Hades.hideLoading();
                } else {
                    healthCarePlanNS.onReimbursementProceduresAction();
                }
            })
            .fail(function (xhr, status, error) {
                bootbox.alert(error);
                Hades.hideLoading();
            });

    },


    onMoreInfoReimbursementResponse: function (event, data) {

        debug.log('Gravar os documentos', data);

        $.post('/hcp_reimbursement_management/reimbursement_request/reimbursement_process_save_clinical_information_response', data, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    bootbox.alert(data.error);

                    Hades.hideLoading();
                } else {
                    healthCarePlanNS.executeGenericAction();
                }
            })
            .fail(function (xhr, status, error) {
                bootbox.alert(error);
                Hades.hideLoading();
            });

    },

    // Cancel Requisition
    openCancelModal: function(){
        Hades.showLoading();

        var params = {
            task_id: healthCarePlanNS._action.task_id,
            wf_id: healthCarePlanNS._action.wf_id,
            wf_status_id: null,
            wf_action_id: healthCarePlanNS._action.wf_action_id
        };

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', healthCarePlanNS.cancelRequisition);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                healthCarePlanNS._callback(false, healthCarePlanNS._action, healthCarePlanNS._row);
            });
    },

    cancelRequisition: function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id: healthCarePlanNS._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id: healthCarePlanNS._row.wf_id,
            wf_status_id: healthCarePlanNS._row.wf_status_id,
            wf_action_id:data.actionId
        };

        $.post('/patients/cancel_requisition', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(data.error, xhr.responseText, xhr, status, data.error);
                    Hades.hideLoading();
                    healthCarePlanNS._callback(false, healthCarePlanNS._action, healthCarePlanNS._row);
                } else {
                    healthCarePlanNS._callback(true, healthCarePlanNS._action, healthCarePlanNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                healthCarePlanNS._callback(false, healthCarePlanNS._action, healthCarePlanNS._row);
            });

        healthCarePlanNS.checkAllRequisitionStatus();


    },
    printEligibilityRequest: function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);
        this._action = action;
        this._callback = callback;
        this._row = row;

        debug.log("oi",action,row);

        var url = "/health_care_portal/eligibility/print_eligibility_request?wf_id="+ row.wf_id +"&task_id="+action.task_id;

        Hades.showDocument(url);

    },


    printDiseaseExpensesForm: function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);
        this._action = action;
        this._callback = callback;
        this._row = row;

        debug.log("printDiseaseExpensesForm", action, row);

        var url = "/hcp_reimbursement_management/reimbursement_request/printDiseaseExpensesForm?wf_id="+ row.wf_id +"&task_id="+action.task_id;

        Hades.showDocument(url);

    },

    printConferenceTicket: function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);
        this._action = action;
        this._callback = callback;
        this._row = row;

        debug.log("printConferenceTicket",action,row);

        var url = "/healthcare_plan/requisition/print_conference_ticket?wf_id="+ row.wf_id +"&task_id="+action.task_id;

        Hades.showDocument(url);

    },

    printPreAuthRequest: function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);
        this._action = action;
        this._callback = callback;
        this._row = row;

        var url = "/health_care_portal/eligibility/print_pre_auth_request?wf_id="+ row.wf_id +"&task_id="+action.task_id;

        Hades.showDocument(url);

    },

    onOpenMoreInfoModal: function(){
        Hades.showLoading();

        var title;

        if (this._action.wf_action_id == 147){
            title = GlobalTranslations['APP_LABEL.2712'];
        } else if (this._action.wf_action_id == 149) {
            title = GlobalTranslations['APP_LABEL.573'];
        } else if (this._action.wf_action_id == 153) {
            title = GlobalTranslations['APP_LABEL.2716'];
        } else if (this._action.wf_action_id == 161) {
            title = GlobalTranslations['APP_LABEL.573'];
        } else if (this._action.wf_action_id == 169) {
            title = GlobalTranslations['APP_LABEL.2788'];
        } else if (this._action.wf_action_id == 174) {
            title = GlobalTranslations['APP_LABEL.2953'];
        } else if (this._action.wf_action_id == 186) {
            title = GlobalTranslations['APP_LABEL.REIMBURSEMENT_MANAGEMENT.REQUEST_INFORMATION'];
        }

        var params = {
            task_id:this._action.task_id,
            wf_id:this._action.wf_id,
            wf_status_id:this._action.to_state_id,
            wf_action_id:this._action.wf_action_id,
            title: title,
            text: '',
            item_id: healthCarePlanNS._action.params.item_id
        };


        debug.log('params modal', params );


        $.get('/modal/more_info_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});


                if (healthCarePlanNS._action.wf_id == globalConstants.WF_HCP_PROCEDURES){
                    $('#more-info-modal-ct').bind('moreInfoModalConfirmed', healthCarePlanNS.onProcedureAction);
                } else if (healthCarePlanNS._action.wf_id == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_PROCEDURES) {
                    $('#more-info-modal-ct').bind('moreInfoModalConfirmed', healthCarePlanNS.onMoreInfoReimbursementRequisition);
                } else if (healthCarePlanNS._action.wf_id == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_PROCESS) {
                    $('#more-info-modal-ct').bind('moreInfoModalResponse', healthCarePlanNS.onMoreInfoReimbursementResponse);
                } else if ( healthCarePlanNS._action.wf_id == globalConstants.WF_HCP_PLANS && healthCarePlanNS._action.wf_action_id == 147 ) {
                    Hades.showLoading();
                    $('#more-info-modal-ct').bind('moreInfoModalConfirmed', healthCarePlanNS.sendEmailNotificationToCallCenter );
                } else if ( healthCarePlanNS._action.wf_id == globalConstants.WF_HCP_PLANS && healthCarePlanNS._action.wf_action_id == 149 ) {
                    Hades.showLoading();
                    $('#more-info-modal-ct').bind('moreInfoModalConfirmed', healthCarePlanNS.sendEmailNotificationToCallCenter );
                } else {
                    $('#more-info-modal-ct').bind('moreInfoModalConfirmed', healthCarePlanNS.executeGenericAction );
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                appointmentNS._callback(false, appointmentNS._action, appointmentNS._row);
            });

    },

    sendEmailNotificationToCallCenter: function () {

        Hades.showLoading();
        var _context = '';
        if ( healthCarePlanNS._action.wf_action_id == 147 ){
            _context = 'SEND_BILLING';
        } else if ( healthCarePlanNS._action.wf_action_id == 149 ){
            _context = 'SEND_INFO';
        }
        else {
            _context = '';
        }

        var params = {
            eligibility_requisition_id: healthCarePlanNS._action.task_id,
            context: _context
        };

        $.post('/health_care_portal/eligibility/send_email_notification_on_workflow', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);
                Hades.hideLoading();
                healthCarePlanNS.executeGenericAction();
        })
        .fail(function (xhr, status, error) {
            Hades.showError(error, xhr.responseText, xhr, status, error);
            Hades.hideLoading();
            appointmentNS._callback(false, appointmentNS._action, appointmentNS._row);
        });

    },

    openCancelConferenceModal: function(){
        Hades.showLoading();

        var title;

        if (this._action.wf_action_id == 158 /* Cancel Conference */){
            title = GlobalTranslations['APP_LABEL.2780'];
        } else if (this._action.wf_action_id == 164 /* Cancel Payment */) {
            title = GlobalTranslations['APP_LABEL.2784']; /* Cancel Reimb. Requisition - Cancel Payment */
        } else {
            title = GlobalTranslations['APP_LABEL.936']; /* Cancel Generic Label */
        }


        var params = {
            task_id:this._action.task_id,
            wf_id:this._action.wf_id,
            wf_status_id:this._action.to_state_id,
            wf_action_id:this._action.wf_action_id,
            title: title,
            text: '',
            item_id: this._action.params.item_id
        };


        debug.log('params modal', params );


        $.get('/modal/cancel_conference_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                if (healthCarePlanNS._action.wf_id == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_PROCESS) {
                    $('#cancel-conference-modal-ct').bind('cancelConferenceConfirmed', healthCarePlanNS.cancelReimbursementPaymentWithReason);
                } else {
                    $('#cancel-conference-modal-ct').bind('cancelConferenceConfirmed', healthCarePlanNS.cancelConferenceWithReason);
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                appointmentNS._callback(false, appointmentNS._action, appointmentNS._row);
            });

    },

    cancelConferenceWithReason:function (event, data) {
        $.fancybox.close(true);
        Hades.hideLoading();

        debug.log('this cancel data', data);

        var params = {
            task_id: healthCarePlanNS._row.task_id,
            wf_id: healthCarePlanNS._row.wf_id,
            wf_status_id: healthCarePlanNS._row.wf_status_id,
            wf_action_id: healthCarePlanNS._action.wf_action_id,

            reason_id: data.other_reason,
            other_reason: data.text,
            date: data.date,
            hour: data.hour
        };

        debug.log('cancelConferenceWithReason', params);

        $.getJSON('/backoffice/health_care_plan/cancel_conference', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    // workflow._callback(false, workflow._action, workflow._row);
                } else {
                    healthCarePlanNS.executeGenericAction();
                    healthCarePlanNS._callback(true, workflow._action, workflow._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                // workflow._callback(false, workflow._action, workflow._row);
            });
    },

    cancelReimbursementPaymentWithReason: function (event, data) {
        $.fancybox.close(true);
        Hades.hideLoading()

        debug.log('this cancel REIMB CONFERENCE     data', data);

        var params = {
            task_id: healthCarePlanNS._row.task_id,
            wf_id: healthCarePlanNS._row.wf_id,
            wf_status_id: healthCarePlanNS._row.wf_status_id,
            wf_action_id: healthCarePlanNS._action.wf_action_id,

            reason_id: data.other_reason,
            other_reason: data.text,
            date: data.date,
            hour: data.hour
        };

        debug.log('cancelReimbursementPaymentWithReason', params);

        $.getJSON('/hcp_reimbursement_management/reimbursement_request/cancel_payment_status', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(data.error, xhr.responseText, xhr, status, data.error);
                    Hades.hideLoading();
                    healthCarePlanNS._callback(false, healthCarePlanNS._action, healthCarePlanNS._row);
                } else {
                    healthCarePlanNS._callback(true, healthCarePlanNS._action, healthCarePlanNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                // workflow._callback(false, workflow._action, workflow._row);
            });

    }

};